var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('div',{staticClass:"landing-page"},[_c('img',{staticClass:"app-logo",attrs:{"alt":"Captura Product Designer","src":_vm.lightLargeLogoUrl}}),_c('div',{staticClass:"subheading"},[_vm._v("Join us in our quest for world domination by logging in below!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }